import {isFeatureEnabled} from 'feature-flags';

import {isNotNil} from 'ramda';

import {featureFlags} from '../utils/featureFlags';
import {usePriceReport} from './usePriceReport';

/**
 * Single source of truth for saved-filters visibility. Both features require the
 * report to be created with a tenant (customerId) — without it presets cannot be
 * fetched and neither the sidebar dropdown nor the panel/overview card renders.
 */
export function useSavedFiltersVisibility() {
  const {requestData} = usePriceReport();
  const customerId = requestData?.customerId ?? null;

  const showSavedFilters =
    isFeatureEnabled(featureFlags.PR_RELATIVE_FILTERS) && isNotNil(customerId);
  const showSavedFiltersPanel =
    showSavedFilters && isFeatureEnabled(featureFlags.PR_RELATIVE_FILTERS_PANEL);

  return {customerId, showSavedFilters, showSavedFiltersPanel};
}
